import React from 'react'
import { Row, Col } from 'antd'
import OverviewCards from './overview-cards'
import OverviewChart from './overview-chart'
import OverviewUsers from './overview-users'
import './overview.scss'

export default ({
    selectedAccount,
    selectedMonth,
    overviewChartData,
    servicesData,
    productsTotalCost,
}) => {
    return (
        <div>
            <OverviewCards
                selectedAccount={selectedAccount}
                selectedMonth={selectedMonth}
                productsTotalCost={productsTotalCost}
            />
            <Row type="flex" gutter={30} className="overview-container">
                <Col span={12}>
                    <div className="overview-chart-container">
                        <OverviewChart
                            overviewChartData={overviewChartData}
                            productsTotalCost={productsTotalCost}
                        />
                    </div>
                </Col>
                <Col span={12}>
                    <div className="overview-chart-container">
                        {/* <OverviewUsers /> */}
                    </div>
                </Col>
                {/* <Col span={12}>
                <Row>
                    <Col span={24}>
                        <div className="overview-service-container">
                            <OverviewServices />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="overview-costful-container">
                            <OverviewServiceTransfers servicesData={servicesData} />
                        </div>
                    </Col>
                </Row>
            </Col> */}
            </Row>
        </div>
    )
}
